module.exports = __webpack_public_path__ + "9c0d8b06353b0277cf729677f64f7b44.svg";